export interface ParsedArgs {
  command: string;
  args: string[];
  options: Record<string, any>;
}

export function parseArgs(args: string[]): ParsedArgs {
  const [command, ...rest] = args;

  if (!command) {
    throw new Error('No command provided');
  }

  const options: Record<string, any> = {};
  const parsedArgs: string[] = [];

  for (let i = 0; i < rest.length; i++) {
    const arg = rest[i];
    if (arg.startsWith('-')) {
      const key = arg.replace(/^-+/, '');
      const value = rest[i + 1];
      if (value && !value.startsWith('-')) {
        options[key] = value;
        i++;
      } else {
        options[key] = true;
      }
    } else {
      parsedArgs.push(arg);
    }
  }

  // Validate command and arguments
  if (!['init', 'mv', 'new', 'done', 'sync', 'update', 'status'].includes(command)) {
    throw new Error(`Unknown command: ${command}`);
  }

  return {
    command,
    args: parsedArgs,
    options
  };
} 